import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h2>{`Contact Me`}</h2>
<p><a parentName="p" {...{
        "href": "https://www.linkedin.com/in/calecorwin"
      }}>{`LinkedIn`}</a></p>
<p><a parentName="p" {...{
        "href": "https://www.github.com/calec"
      }}>{`Github`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      